module.exports = __webpack_public_path__ + "media/images/admin/dashboard-users-aef68332a7effd839313d2c8699d448e.jpg";